
import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// fetch all queries with pagination
export const getQueryForm = async (params = {}) => {
    try {
        const response = await api.get(`${API_URL}/query`, { params });
        return response.data;
    } catch (error) {
        handleUnauthorizedOrForbidden(error);
        throw error;
    }
};

// update query
export const updateQueryForm = async (id, queryData) => {
    try {
        const response = await api.put(`${API_URL}/query/${id}`, queryData);
        return response.data;
    } catch (error) {
        handleUnauthorizedOrForbidden(error);
        throw error;
    }
};